import {useSelector} from "react-redux";
import {Navigate, Outlet} from "react-router-dom";
import React from "react";
import {homePath} from "./routes";


export const RestrictedRoute = () => {
  // 1️⃣ Comprueba primero en el store Redux...
  const authToken = useSelector(state => state.authToken.token);
  // 2️⃣ ...y si no hay, mira en localStorage
  const localToken = localStorage.getItem("token");
  // 3️⃣ Decide:
  const isLoggedIn = !!(authToken || localToken);

  // Si está logueado, redirige a HOME (replace para no guardar en history)
  if (isLoggedIn) {
    return <Navigate to={homePath} replace />;
  }

  // Si NO está logueado, deja pasar a las rutas hijas
  return <Outlet />;
};